import { Controller } from "stimulus"

export default class extends Controller {
  initialize() {
    const buttons = document.querySelectorAll('.btn.btn-pay')

    buttons.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault()
        const url = e.target.dataset.url

        fetch(url, {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
        }).then(res => {
          return res.json()
        }).then(res => {
          window.location.href = res.url
        })
          .catch(error => console.error(error))
      })
    })
  }
}
